import React from "react";
import { HiX } from "react-icons/hi";

type PROPS = {
  action: () => void;
};

const XButton: React.FC<PROPS> = (props) => {
  return (
    <button className="light-gray p-2 text-2xl border" onClick={props.action}>
      <HiX className="text-white" />
    </button>
  );
};
export default XButton;
